import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
};
const DefaultColor = "#de3f6b";
function AE({
  size = 16,
  color = DefaultColor
}: Props): JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color}><path  d="M7.314 8.25h.678c1.06.1 2.04.616 2.765 1.358 1.507 1.529 2.335 3.686 4.253 4.824 1.386.823 3.324.15 4.005-1.24q.522-.008 1.042-.005c-.477 1.413-1.866 2.427-3.386 2.563h-.56c-.935-.075-1.844-.423-2.552-1.024-1.027-.843-1.687-1.999-2.486-3.028-.687-.91-1.388-1.932-2.524-2.346-1.405-.509-3.12.288-3.633 1.64-.45 1.115-.084 2.497.923 3.21.754.565 1.805.775 2.711.447 1.006-.351 1.753-1.149 2.326-1.995q.338.47.664.95c-.891 1.085-2.127 2.017-3.597 2.146H7.34c-1.852-.124-3.462-1.647-3.59-3.445v-.59C3.87 9.922 5.46 8.38 7.314 8.25m8.76 0h.563c1.87.118 3.46 1.671 3.613 3.47v.922c-1.543.014-3.087.005-4.63.006q.003-.404 0-.808c1.22-.003 2.438.005 3.655-.003-.086-.477-.198-.965-.49-1.37-.713-1.052-2.22-1.483-3.424-1.027-.96.345-1.683 1.1-2.24 1.905q-.324-.447-.634-.904c.88-1.101 2.107-2.054 3.587-2.191" /></Svg>;
}
AE.DefaultColor = DefaultColor;
export default AE;